import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useLocation } from 'react-router';
import qs from 'qs';
import { withSnackbar } from 'notistack';
import _isNull from 'lodash/isNull';
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import AxiosHeaders from '../../helpers/AxiosHeaders';
import PushSnackbarMessage from '../../helpers/PushSnackbarMessage';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});

const BillingPlan = ({ classes, enqueueSnackbar }) => {
  const {
    accountFeaturesList,
    upcomingBillingPlan,
    billingPlans,
    productCount,
  } = window.gon;
  const [featuresList, setFeaturesList] = useState(accountFeaturesList || []);
  const [newBillingPlan, setNewBillingPlan] = useState(upcomingBillingPlan);
  const [billingAmount, setBillingAmount] = useState(_isNull(upcomingBillingPlan) ? 0 : upcomingBillingPlan.amount/100);
  const enableCustomBillingAmount = (!_isNull(upcomingBillingPlan) && newBillingPlan.nickname === 'Premium - Custom');
  const handleChangePlan = (event) => {
    const newPlan = billingPlans.find((plan) => plan.id == event.target.value);
    setFeaturesList(featuresList);
    setNewBillingPlan(newPlan);
    setBillingAmount(newPlan.amount/100);
  };
  const handleCheck = (event, feature) => {
    const clickFeature = feature;
    const indexFeature = featuresList.indexOf(feature);
    clickFeature.enable = event.target.checked;
    featuresList.splice(indexFeature, 1, clickFeature);
    setFeaturesList([...featuresList]);
  };
  const location = useLocation();
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const handleSubmitBillingFeatures = (meth) => {
    let data = new FormData();
    let method = meth || 'PUT';
    let url = `/admin/accounts/${params._account}/process_billing_features`;

    data.append('account[id]', params._account);
    if (!_isNull(newBillingPlan)) {
      if (newBillingPlan.nickname === 'Premium - Custom') {
        const newBillingAmount = parseInt(billingAmount);
        let exitsPlan;
        if (exitsPlan = billingPlans.find(plan => plan.amount/100 === newBillingAmount)) {
          data.append('account[upcoming_stripe_plan]', exitsPlan.id);
        } else {
          data.append('customer[custom_ammount]', billingAmount);
          data.append('account[upcoming_stripe_plan]', newBillingPlan.id);
        }
      } else {
        data.append('account[upcoming_stripe_plan]', newBillingPlan.id);
      }
    }
    featuresList.forEach((feature, index) => {
      data.append(`account[accounts_features_attributes][${index}][id]`, feature.id);
      data.append(`account[accounts_features_attributes][${index}][enable]`, feature.enable);
    });

    axios({
      url,
      method,
      headers: Object.assign({ 'Content-Type': 'multipart/form-data' }, AxiosHeaders),
      data,
    }).then((res) => {
      if (res.status === 200) {
        PushSnackbarMessage(enqueueSnackbar, 'Update successfully!', 'success');
      }
      window.location.reload();
    }).catch(() => {
      PushSnackbarMessage(enqueueSnackbar, 'Unable to save!', 'error');
    });
  };
  const [newPlanName, setNewPlanName] = useState(null);
  const [newPlanPrice, setNewPlanPrice] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const handleClickOpen = () => {
    setOpenDialog(true);
  };
  const handleClose = () => {
    setOpenDialog(false);
  };
  const createPlan = () => {
    let data = new FormData();
    let method = 'POST';
    let url = `/admin/accounts/${params._account}/create_stripe_plan`;
    if (!_isNull(newPlanName) && !_isNull(newPlanPrice)) {
      data.append('customer[custom_amount]', newPlanPrice);
      data.append('customer[custom_name]', newPlanName);
    }

    axios({
      url,
      method,
      headers: Object.assign({ 'Content-Type': 'multipart/form-data' }, AxiosHeaders),
      data,
    }).then((res) => {
      window.location.reload();
    }).catch(() => {
      PushSnackbarMessage(enqueueSnackbar, 'Unable to save!', 'error');
    });
  };

  return (
    <Fragment>
      <div className="card-header">
        <h3 className="card-title">Billing</h3>
      </div>

      <div className="card-body">
        <Grid container className="text-left">
          <Grid item xs={6}>
            <FormControl variant="outlined" size="small" className={`${classes.formControl} ml-0 mt-0`}>
              <label className="form-label">
                <span className="label-text">Upcoming Billing Plan</span>
              </label>
              <Select
                labelId="simple-select-outlined-label"
                id="simple-select-outlined"
                value={_isNull(newBillingPlan) ? 'no_change' : newBillingPlan.id}
                onChange={handleChangePlan}
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value='no_change' disabled>
                  <em>Select billing plan</em>
                </MenuItem>
                {billingPlans.map((plan, index) => {
                  const componentID = `menu-item-${index}-${plan.id}`;

                  return (
                    <MenuItem value={plan.id} key={componentID}>
                      {plan.nickname}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          {!_isNull(newBillingPlan) &&
            <Fragment>
              <Grid item xs={4}>
                <label className="form-label">
                  <span className="label-text">Pricing Amount</span>
                </label>
                <TextField
                  variant="outlined"
                  size="small"
                  className="w-2/3"
                  value={billingAmount}
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                  }}
                  onChange={e => setBillingAmount(e.target.value)}
                  disabled={!enableCustomBillingAmount}
                />
              </Grid>
              <Grid item xs={2}>
                <label className="form-label">
                  <span className="label-text">Renews next</span>
                </label>
                <span>{newBillingPlan.renewsAt}</span>
              </Grid>
            </Fragment>
          }
        </Grid>
        <Grid container p={3} className="mt-6">
          <Button variant="contained" color="primary" className="capitalize" onClick={handleClickOpen}>
            Create New Plan
          </Button>
          <Dialog open={openDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Create Plan</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                label="Name"
                type="email"
                fullWidth
                value={newPlanName || ""}
                onChange={e => setNewPlanName(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Price"
                type="number"
                value={newPlanPrice || ""}
                onChange={e => setNewPlanPrice(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button onClick={createPlan} color="primary">
                Create
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
        <Grid container p={3} className="mt-6">
          <Grid item xs={6}>
            <label className="form-label">
              <span className="label-text">Products</span>
            </label>
          </Grid>
          <Grid item xs={4}>
            <div>
              <p>Current count</p>
              <span>{productCount}</span>
            </div>
          </Grid>
          <Grid item xs={2}>
            <div>
              <p>Limit</p>
              <TextField variant="outlined" size="small" />
            </div>
          </Grid>
        </Grid>

        <Paper elevation={0} variant="outlined" square className="p-6 mt-6">
          <Grid container>
            <Grid item xs={12}>
              <label className="form-label">
                <span className="label-text">Premium features</span>
              </label>
            </Grid>
          </Grid>

          {featuresList.map((feature, index) => {
            const componentID = `feature_${index}_${feature.id}`;

            return (
              <Grid container className="text-left mt-8" key={componentID}>
                <Grid item xs={4} className="mt-auto mb-auto">
                  <span>{feature.title}</span>
                </Grid>
                <Grid item xs={2} className="mt-auto mb-auto">
                  <Switch
                    checked={feature.enable}
                    onChange={e => handleCheck(e, feature)}
                    color="primary"
                    name="checkedA"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                    className="m-auto"
                  />
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <p>Current count</p>
                    <span>Not yet</span>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div>
                    <p>Limit</p>
                    <TextField variant="outlined" size="small" />
                  </div>
                </Grid>
              </Grid>
            );
          })}
        </Paper>
      </div>

      <div className="card-footer">
        <Button variant="contained" color="primary" className="capitalize" onClick={() => handleSubmitBillingFeatures('')}>
          Update
        </Button>
      </div>
    </Fragment>
  );
};

BillingPlan.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
};

export default withSnackbar(withStyles(styles)(BillingPlan));
